
import { createTheme } from "@mui/material/styles";
const theme = createTheme({
    palette: {
        primary: {
            main: "#1468A2",
        },
    },
    typography: {
        fontFamily: ["Poppins, sans-serif"].join(","),
        variants: [],
    },
    components: {
        MuiButton: {
            styleOverrides: {
                // Name of the slot
                root: {
                    fontSize: "1rem",
                    padding: "9.2px 15px",
                    textTransform: "none",
                },
            },
            variants: [
                {
                    props: { variant: "contained" },
                    style: {
                        backgroundColor: "#1468A2",
                        width: "240px",
                        "&:hover": {
                            backgroundColor: "#1468A2",
                            color: "#fff",
                        },
                    },
                },
            ],
        },
        MuiStepIcon: {
            styleOverrides: {
                root: {
                    height: "1.3em",
                    width: "1.3em",
                },
            },
        },
        MuiStepConnector: {
            styleOverrides: {
                root: {
                    top: "15px",
                },
            },
        },
    },
});

theme.typography.h2 = {
    fontSize: 28,
    fontWeight: 600,
    color: "#1468A2",
    lineHeight: "36px",
    marginBottom: "18px",
};
theme.typography.h3 = {
    fontSize: 16,
    fontWeight: 500,
    color: "#666",
    marginBottom: "1rem",
};

export default theme; 